import { render } from "./endSoon.html?vue&type=template&id=9bbf5964&scoped=true&ts=true&external"
import script from "./EndSoon.vue?vue&type=script&lang=ts"
export * from "./EndSoon.vue?vue&type=script&lang=ts"

import "./EndSoon.vue?vue&type=style&index=0&id=9bbf5964&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bbf5964"]])

export default __exports__